import React from "react";
import CreationModal from "../../components/creation";

const SupportingArticle = () => {
  return (
    <div className="">
      <CreationModal />
    </div>
  );
};

export default SupportingArticle;
